import { ButtonHTMLAttributes, useRef } from "react";
import "./styles.css";

interface ButtonOnlyTitleProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  title: string;
  theme?: "dark" | "info" | "light" | "success" | "urgent";
  throttleMs?: number;
}

export function ButtonOnlyTitle({
  title,
  theme,
  id,
  onClick,
  throttleMs = 100,
  ...rest
}: ButtonOnlyTitleProps) {
  const lastClickTimeRef = useRef(0);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    const now = Date.now();
    const timeSinceLastClick = now - lastClickTimeRef.current;

    // throttling
    if (timeSinceLastClick >= throttleMs) {
      lastClickTimeRef.current = now;
      onClick?.(event);
    }
  };

  return (
    <button
      className={`buttononlytitle buttononlytitle--${theme}`}
      id={id}
      type="button"
      onClick={handleClick}
      {...rest}
    >
      <h6>{title}</h6>
    </button>
  );
}
